import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { Topic } from 'app/models/topic';
import { ModalShareComponent } from 'app/shared/components/modal-share/modal-share.component';
import { ModalContactComponent } from 'app/shared/components/modal-contact/modal-contact.component';
import { FileType } from 'app/models/file-type.enum';
import { Source } from 'app/models/source.enum';
import { FilesService } from 'app/services/files.service';
import * as FileSaver from 'file-saver';
import { File } from 'app/models/file';
import {GoogleTagManagerService} from '../../../services/google-tag-manager.service';

@Component({
  selector: 'app-topic-info',
  templateUrl: './topic-info.component.html',
  styleUrls: ['./topic-info.component.scss'],
  providers: [FilesService]
})
export class TopicInfoComponent implements OnInit {

  @Input() topic: Topic;
  bsModalRef: BsModalRef;

  constructor(
    private router: Router,
    private modalService: BsModalService,
    private fileService: FilesService,
    private gtmService: GoogleTagManagerService
  ) { }

  ngOnInit() { }

  download(event) {
    if (event.files) {
      // Commented until new tag plan resolvement
      // this.gtmService.pushEvent(`Download Topic - ${event.displayName}`);
      event.files.forEach((file: File) => this.getFile(file));
    }
  }

  private showModal(component: any) {
    this.bsModalRef = this.modalService.show(component, {
      class: 'modal-lg',
      backdrop: 'static'
    });
    this.bsModalRef.content.data = this.topic;
  }

  private getFile(file: File) {
    if (file.contentType === FileType.Doc || file.contentType === FileType.Img) {
      const id = file.source === Source.Document ? file.id : file.documentId;
      this.fileService
        .download(id)
        .subscribe((result) => FileSaver.saveAs(result.content, result.name));
    }
    this.gtmService.pushEvent(`Download - ${file.displayName}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/topic-info/topic-info.component.ts